import React from 'react';
import { DocPageLayout } from '../../components/DocPageLayout';
import { CodeBlock } from '../../components/CodeBlock';
import { InfoBox } from '../../components/InfoBox';
export function ApiTokenizationPage() {
  return <DocPageLayout title="Tokenization API" description="Create and manage payment tokens for secure card storage and reuse." breadcrumbs={[{
    label: 'API Reference',
    id: 'api-overview'
  }, {
    label: 'Tokenization'
  }]} sections={[{
    id: 'create-token',
    title: 'Create Token'
  }, {
    id: 'retrieve-token',
    title: 'Retrieve Token'
  }, {
    id: 'update-token',
    title: 'Update Token'
  }, {
    id: 'delete-token',
    title: 'Delete Token'
  }]} data-id="element-721">
      <h2 id="create-token" className="text-2xl font-bold text-gray-900 mt-6 mb-4 border-b border-gray-200 pb-2" data-id="element-722">
        Create Token
      </h2>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6 font-mono text-sm" data-id="element-723">
        <span className="inline-block px-2 py-0.5 rounded-full text-xs font-bold bg-blue-100 text-blue-700 mr-2" data-id="element-724">
          POST
        </span>
        <span className="text-gray-600" data-id="element-725">/merchant/</span>
        <span className="text-blue-600" data-id="element-726">{'{merchantId}'}</span>
        <span className="text-gray-600" data-id="element-727">/token</span>
      </div>
      <CodeBlock language="JSON" title="Request" code={`{
  "session": {
    "id": "SESSION0002abcdef1234567890"
  },
  "sourceOfFunds": {
    "type": "CARD"
  }
}`} data-id="element-728" />
      <CodeBlock language="JSON" title="Response" code={`{
  "result": "SUCCESS",
  "token": "9111111111111111",
  "repositoryId": "TOKEN_REPO_001",
  "sourceOfFunds": {
    "provided": {
      "card": {
        "brand": "MASTERCARD",
        "expiry": { "month": "12", "year": "27" },
        "fundingMethod": "CREDIT",
        "number": "512345xxxxxx0008",
        "scheme": "MASTERCARD"
      }
    },
    "type": "CARD"
  },
  "status": "VALID",
  "usage": {
    "lastUsed": "2026-03-08",
    "lastUpdated": "2026-03-08"
  }
}`} data-id="element-729" />

      <h2 id="retrieve-token" className="text-2xl font-bold text-gray-900 mt-10 mb-4 border-b border-gray-200 pb-2" data-id="element-730">
        Retrieve Token
      </h2>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6 font-mono text-sm" data-id="element-731">
        <span className="inline-block px-2 py-0.5 rounded-full text-xs font-bold bg-green-100 text-green-700 mr-2" data-id="element-732">
          GET
        </span>
        <span className="text-gray-600" data-id="element-733">/merchant/</span>
        <span className="text-blue-600" data-id="element-734">{'{merchantId}'}</span>
        <span className="text-gray-600" data-id="element-735">/token/</span>
        <span className="text-blue-600" data-id="element-736">{'{tokenId}'}</span>
      </div>

      <h2 id="update-token" className="text-2xl font-bold text-gray-900 mt-10 mb-4 border-b border-gray-200 pb-2" data-id="element-737">
        Update Token
      </h2>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6 font-mono text-sm" data-id="element-738">
        <span className="inline-block px-2 py-0.5 rounded-full text-xs font-bold bg-amber-100 text-amber-700 mr-2" data-id="element-739">
          PUT
        </span>
        <span className="text-gray-600" data-id="element-740">/merchant/</span>
        <span className="text-blue-600" data-id="element-741">{'{merchantId}'}</span>
        <span className="text-gray-600" data-id="element-742">/token/</span>
        <span className="text-blue-600" data-id="element-743">{'{tokenId}'}</span>
      </div>

      <h2 id="delete-token" className="text-2xl font-bold text-gray-900 mt-10 mb-4 border-b border-gray-200 pb-2" data-id="element-744">
        Delete Token
      </h2>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6 font-mono text-sm" data-id="element-745">
        <span className="inline-block px-2 py-0.5 rounded-full text-xs font-bold bg-red-100 text-red-700 mr-2" data-id="element-746">
          DELETE
        </span>
        <span className="text-gray-600" data-id="element-747">/merchant/</span>
        <span className="text-blue-600" data-id="element-748">{'{merchantId}'}</span>
        <span className="text-gray-600" data-id="element-749">/token/</span>
        <span className="text-blue-600" data-id="element-750">{'{tokenId}'}</span>
      </div>
      <InfoBox type="info" title="Token Lifecycle" data-id="element-751">
        Tokens remain valid until the associated card expires or the token is
        explicitly deleted. The gateway automatically updates tokens when card
        details change through network token updates.
      </InfoBox>
    </DocPageLayout>;
}